import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-container',
  standalone: true,
  imports: [],
  templateUrl: './loading-container.component.html',
  styleUrl: './loading-container.component.css'
})
export class LoadingContainerComponent {

}
